<script setup>
import { pathOr } from 'ramda'
import { ref, computed } from 'vue'
import RefreshSpinner from '@/components/ui/RefreshSpinner.vue'

const props = defineProps({
  value: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: false,
    default: null
  },
  propsToSearch: {
    type: Array,
    required: false,
    default: () => ['name']
  },
  tableColumns: {
    type: Array,
    required: true
  },
  actions: {
    type: Array,
    required: true
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['on-refresh'])

const search = ref('')

const queriedData = computed(() => {
  if (!search.value) {
    return props.value
  }
  let result = props.value.filter(row => {
    let isIncluded = false
    for (let key of props.propsToSearch) {
      let rowValue = pathOr('', key.split('.'), row).toString()
      if (
        rowValue.includes &&
        rowValue.toLowerCase().includes(search.value.toLowerCase())
      ) {
        isIncluded = true
      }
    }
    return isIncluded
  })
  return result
})

function refreshList () {
  emit('on-refresh', 'refresh')
}
</script>

<template>
  <v-card flat>
    <v-card-text>
      <v-card-title>
        <h1 class="text-h4 mr-2">{{ props.title }}</h1>
        <refresh-spinner v-model="props.isLoading" @click="refreshList"></refresh-spinner>
        <!-- <v-icon @click="refreshList">mdi-refresh</v-icon> -->
        <v-spacer></v-spacer>
        <v-text-field @keydown.native.escape="search = ''" label="Search" single-line hide-details clearable
        v-model="search"></v-text-field>
      </v-card-title>
      <v-card-subtitle v-if="props.subtitle">{{  props.subtitle }}</v-card-subtitle>
    </v-card-text>
    <v-data-table
      :headers="tableColumns"
      :items="queriedData"
      item-key="id"
      class="elevation-0"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <template v-for="(rowAction, index) in props.actions">
          <v-tooltip top :key="index">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                medium
                class="mr-2"
                @click="rowAction.action(item)"
              >{{ rowAction.icon }}</v-icon>
            </template>
            <span>{{ rowAction.title }}</span>
          </v-tooltip>
        </template>
      </template>
    </v-data-table>
  </v-card>
</template>
